import React from 'react';
import { Path, Rect, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface CreditCardIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const CreditCardIcon: React.FC<CreditCardIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Rect
        x="2"
        y="5"
        width="20"
        height="14"
        rx="2"
        stroke={colors[color]}
        strokeWidth="2"
        fill="none"
      />
      <Path d="M2 10H22" stroke={colors[color]} strokeWidth="2" />
      <Path d="M6 15H10" stroke={colors[color]} strokeWidth="2" />
    </Svg>
  );
};

CreditCardIcon.displayName = 'CreditCardIcon';
export { CreditCardIcon };
